
import { iterateOverFilters, getColumnParamsByKeyForRequest, isResponseForGrouping } from './utils'
import { msToTime } from '../../../libs/msToTime'

export default {
  middlewareForRequest: ({ loadOptions }) => {
    /* set chatDuration groupInterval */
    if (loadOptions.group) {
      let newGroup = []
      loadOptions.group.forEach(group => {
        const { selector, /* desc, */ isExpanded, groupInterval } = group
        const { groupInterval: groupIntervalFromConfig } = getColumnParamsByKeyForRequest(selector)
        if (selector === 'chatDuration') {
          if (isExpanded) return /* remove group item */
          if (groupIntervalFromConfig) {
            newGroup.push({ ...group, groupInterval: groupIntervalFromConfig })
          }
        } else if (!groupInterval && groupIntervalFromConfig) {
          newGroup.push({ ...group, groupInterval: groupIntervalFromConfig })
        } else {
          newGroup.push({ ...group })
        }
      })
      loadOptions.group = newGroup
    }

    loadOptions.filter = iterateOverFilters(loadOptions.filter, ([paramKeys, logicalOperator, filterValue]) => {
      if (paramKeys === 'messagesCount' && logicalOperator === '=' && typeof filterValue === 'string' && ~filterValue.indexOf(' - ')) {
        const [first, last] = filterValue.split(' - ')
        return [['messagesCount', '>=', Number(first)], 'and', ['messagesCount', '<', Number(last)]]
      }
      if (paramKeys === 'charsCount' && logicalOperator === '=' && typeof filterValue === 'string' && ~filterValue.indexOf(' - ')) {
        const [first, last] = filterValue.split(' - ')
        return [['charsCount', '>=', Number(first)], 'and', ['charsCount', '<', Number(last)]]
      }
      return [paramKeys, logicalOperator, filterValue]
    })
    return loadOptions
  },

  middlewareForResponse: ({ transcripts, loadOptions }) => {
    if (!isResponseForGrouping(transcripts)) return transcripts

    let newTranscript = []
    transcripts.forEach(transcript => {
      if (transcript.transcripts !== undefined) transcript.items = transcript.transcripts
      if (!transcript.items) transcript.items = null

      if (loadOptions?.group[0]?.selector) {
        const { dataField, groupInterval } = getColumnParamsByKeyForRequest(loadOptions.group[0].selector)
        if (loadOptions.group[0].desc === undefined) { /* headerFilter */
          if (dataField === 'chatDuration') { /* datetime in string */
            if (transcript.key === null) {
              transcript.key = 'N/A'
            } else {
              transcript.key =
                  `${msToTime(transcript.key / 1000)} - ${msToTime((+transcript.key + groupInterval) / 1000)}`
            }
          }
        } else if (groupInterval) { /* regular grouping */
          if (dataField === 'messagesCount' || dataField === 'charsCount') { /* number */
            transcript.key = `${transcript.key} - ${transcript.key + groupInterval}`
          }
          if (dataField === 'chatDuration') { /* datetime in string */
            if (transcript.key === null) {
              transcript.key = 'N/A'
            } else {
              transcript.key =
                `${msToTime(transcript.key / 1000)} - ${msToTime((+transcript.key + groupInterval) / 1000)}`
            }
          }
        }
      }

      newTranscript.push(transcript)
    })
    return newTranscript
  },
}
